module.exports = __webpack_public_path__ + "img/background1.56338995.png";